<template>
  <v-card
    class="px-4 pt-4"
  >
    <h3>
      <v-layout
        row
        align-center
        justify-space-between
      >
        <v-flex>
          <v-layout
            row
            align-center
          >
            <slot name="title"/>
          </v-layout>
        </v-flex>
        <v-flex xs1>
          <slot name="actions"/>
        </v-flex>
      </v-layout>
    </h3>
    <slot/>
    <v-divider class="mt-4"/>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '0'
    }
  }
}
</script>
